import { render, staticRenderFns } from "./InputShow.vue?vue&type=template&id=71c0c50b&scoped=true"
import script from "./InputShow.vue?vue&type=script&lang=js"
export * from "./InputShow.vue?vue&type=script&lang=js"
import style0 from "./InputShow.vue?vue&type=style&index=0&id=71c0c50b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0c50b",
  null
  
)

export default component.exports